<template>
    <m-onboard v-bind="$attrs" v-on="$listeners">
        <template #template="{item, index}">
            <m-card-onboard-story :item="item" :index="index"/>
        </template>
    </m-onboard>
</template>

<script>
    import MOnboard from "@modules/onboards/m-onboard";
    import MCardOnboardStory from "@modules/cards/concrete/m-card-onboard-story";
    export default {
        name: "m-onboard-story",
        inheritAttrs: false,
        components: {MCardOnboardStory, MOnboard}
    }
</script>

<style lang="scss" scoped>
    //
</style>